export const ConfirmTypeEnum = {
  RepoConfirm: 'RepoConfirm',
} as const;
export type ConfirmTypeEnum = (typeof ConfirmTypeEnum)[keyof typeof ConfirmTypeEnum];

export interface RepoConfirm {
  CashCurrency?: string;
  CollateralAsset?: string;
  HaircutPct?: string;
  StartTime?: string;
  EndTime?: string;
  ReferencePrice?: string;
}

export function getRepoConfirm({
  ConfirmType,
  Confirm,
}: {
  ConfirmType?: ConfirmTypeEnum;
  Confirm?: object;
}): RepoConfirm | undefined {
  if (ConfirmType === ConfirmTypeEnum.RepoConfirm && Confirm != null) {
    return Confirm as RepoConfirm;
  }

  return undefined;
}
